
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, InputGroup, Button } from 'react-bootstrap'
import { momentHelper } from './helpers'
import SelectDate from 'component/element/SelectDate'
import SelectObject from 'component/element/SelectObject'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome';
import CKAutocomplete from 'component/element/CKAutocomplete';
import IframeModal from 'component/element/IframeModal'
import DatePicker from 'component/element/DatePicker'

import './report.css'
// import { connect } from 'react-redux';

const mockJson = {
  clientList: [
    {
      clientId: 'all',
      clientName: 'ทั้งหมด'
    },
    {
      clientId: 'owner_person',
      clientName: 'เจ้าของรถ (บุคคล)'
    },
    {
      clientId: 'owner_company',
      clientName: 'เจ้าของรถ (บริษัท)'
    },
    {
      clientId: 'insurer',
      clientName: 'บริษัทประกัน/เงินสด'
    }
  ],

  incomeList: [
    {
      car_registration_no: 'กข 1234',
      chassisNo: '',
      claimNo: '2015-15331-001491',
      ownerName: 'บ.ไทยน้ำทิพย์',
      payerBy: 'วิริยะ',
      carDetail: 'Honda City',
      parkDate: '07/05/2017',
      appointmentDate: '07/05/2017',
      deliverDate: '17/05/2017',
      autionPrice: '110000',
      autionConfirmPrice: '10000',
      quotationPrice: '117967.50',
      finalPrice: '81800.00 ',
      paymentAmount: '81800.00',
      balance: '81800',
      billingDate: '',
      billingNo: '',
      paymentStatusText: 'รับเงินแล้ว',
      paymentDate: ''
    }
  ],
  clientName: 'กรุงเทพประกันภัย',
  updatedDate: '2017',
  listCount: 100
}
class ReportKKCBalance extends Component {
  constructor(props) {
    super(props)
    const WHOLE_YEAR = momentHelper.getMonth() //'00'

    this.state = {
      activePage: 1,
      clientId: mockJson.clientList[0].clientId,
      month: WHOLE_YEAR,
      year: momentHelper.getYear(),
      data: mockJson,
      query: '',
      queryList: [],
      isRange: false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear()
    }
    this.refTableId = 'ReportKKCBalance-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.query,this.state.clientId)
      this.loadIncomeCategory(this.state.year,this.state.clientId)
    }
  }

  loadData(year='',month='',query='',cat='') {
    let {data} = this.state
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadBalanceList(year,month,cat,query,(result)=>{
      data.incomeList = result.data
      this.setState({data:data})
    })
  }

  loadDataRange(start='',end='',query='',cat='') {
    let {data} = this.state
    ReportStore.loadBalanceListRange(start,end,cat,query,(result)=>{
      data.incomeList = result.data
      this.setState({data:data})
    })
  }

  loadIncomeCategory(year='',key='') {
    ReportStore.loadIncomeCategory(year,(result)=>{
      let queryList = []
      if (key==='all') {
        result.data.owner_person.forEach(function(item,index) {
          queryList.push({
            label:item,
            value:item
          })
        })
        result.data.owner_company.forEach(function(item,index) {
          queryList.push({
            label:item,
            value:item
          })
        })
        result.data.insurer.forEach(function(item,index) {
          queryList.push({
            label:item,
            value:item
          })
        })
      } else {
        result.data[key].forEach(function(item,index) {
          queryList.push({
            label:item,
            value:item
          })
        })
      }  
      this.setState({queryList:queryList,query:''})
    })
  }

  getRowTextColor(insurer_id) {
    if (insurer_id==='0'||insurer_id===0||insurer_id==='') {
      return 'color-blue'
    } else {
      return 'color-red'
    }
  }

  getNumberFormat(val) {
    if (val!==''&&val!==undefined&&val!==null&&!isNaN(val)) {
      return parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 2})
    }
    return val
  }

  renderBody() {
    let {data} = this.state
    if (data.incomeList.length===0||data.incomeList===undefined) {
      return(<tr><td colSpan={20}>ไม่พบข้อมูล</td></tr>)
    } else {
      return this.state.data.incomeList.map((item,index)=>
        (
          <tr key={index}>
            <td className='text-center'>{index+1}</td>
            <td className='text-center'>{item.car_registration_no}</td>
            <td className={this.getRowTextColor(item.insurer_id)}>{item.owner_name}</td>
            <td className={this.getRowTextColor(item.insurer_id)}>{item.paid_by}</td>
            <td className={this.getRowTextColor(item.insurer_id)}>{item.car_detail}</td>
            <td className='text-center'>{item.entrance_date}</td>
            <td className='text-center color-red'>{item.appointment_date}</td>
            <td className='text-center color-blue bg-4'>{item.delivering_date}</td>
            <td className='text-right bg-5'>{this.getNumberFormat(item.auction_price)}</td>
            <td className='text-right color-blue bg-2'>{this.getNumberFormat(item.confirm_price)}</td>
            <td className='text-right color-red'>{this.getNumberFormat(item.expense_office)}</td>
            <td className='text-right color-red'>{this.getNumberFormat(item.expense_mechanic)}</td>
            <td className='text-right color-red'>{this.getNumberFormat(item.expense_stock)}</td>
            <td className='text-right bg-2'>{this.getNumberFormat(item.expense_amount)}</td>
          </tr>
        )
      )
    }
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid table-report-kkc-income' style={{width:'2100px'}}>
          <thead>
            <tr>
              <th className='text-center bg-1' rowSpan={2} style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center bg-1' rowSpan={2} style={{width:'180px'}}>ทะเบียนรถ</th>
              <th className='text-center bg-1' rowSpan={2} style={{width:'200px'}}>เจ้าของรถ</th>
              <th className='text-center bg-1' rowSpan={2} style={{width:'200px'}}>บริษัทประกัน/เงินสด/เครดิต</th>
              <th className='text-center bg-1' rowSpan={2} style={{width:'200px'}}>รายการซ่อม ชนิดรถ</th>
              <th className='text-center bg-1' colSpan={3}>วัน-เดือน-ปี</th>
              <th className='text-center bg-2' colSpan={6}>เครดิต / เงินสด / ประกัน</th>
            </tr>
            <tr>
              <th className='text-center bg-1' style={{width:'100px'}}>รับรถ</th>
              <th className='text-center bg-1' style={{width:'100px'}}>กำหนดส่ง</th>
              <th className='text-center bg-1' style={{width:'100px'}}>รถออกจริง</th>
              <th className='text-center bg-4' style={{width:'100px'}}>ราคาประมูลและเงินสด</th>
              <th className='text-center bg-1' style={{width:'100px'}}>ราคายืนยัน</th>
              <th className='text-center bg-1' style={{width:'100px'}}>ค่าแรงธุรการ/ค่าน้ำ/ค่าไฟ</th>
              <th className='text-center bg-1' style={{width:'100px'}}>ค่าแรงช่าง</th>
              <th className='text-center bg-1' style={{width:'100px'}}>ค่าอะไหล่ + วัสดุสิ้นเปลือง</th>
              <th className='text-center bg-4' style={{width:'100px'}}>คงเหลือ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={8} className='text-center bg-1'>{'รวมรายการรถเข้าซ่อม '+this.getAll()+' รายการ ซ่อมเสร็จ '+this.getSuccess()+' คัน กำลังซ่อม '+this.getNotSuccess()+' คัน'}</th>
              <th className='text-right bg-2'>{this.getSummary('auction_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('confirm_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('expense_office').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('expense_mechanic').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('expense_stock').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th className='text-right bg-2'>{this.getSummary('expense_amount').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
            </tr>
            <tr>
              <th colSpan={8} className='bg-none'></th>
              <th colSpan={2} className='text-center bg-1'>รวมราคายืนยัน</th>
              <th colSpan={3} className='text-center bg-2'>รวมค่าใช้จ่าย</th>
              <th className='text-center bg-2'>รวมคงเหลือ</th>
            </tr>
            <tr>
              <th colSpan={8} className='bg-none'></th>
              <th colSpan={2} className='text-right bg-1'>{this.getSummary('confirm_price').toLocaleString(undefined, {maximumFractionDigits: 2})}</th>
              <th colSpan={3} className='text-right bg-2'>{this.getSummaryExpense().toLocaleString(undefined, {maximumFractionDigits: 2})+' ('+this.getSummaryPercent('exp')+'%)'}</th>
              <th className='text-right bg-2'>{this.getSummary('expense_amount').toLocaleString(undefined, {maximumFractionDigits: 2})+' ('+this.getSummaryPercent('balance')+'%)'}</th>
            </tr>  
          </tfoot>
        </table>
      </div>
    )
  }

  getAll() {
    let {data} = this.state
    return data.incomeList.length
  }

  getSuccess() {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      if (item.work_status>='2') {
        sum = parseFloat(1) + parseFloat(sum) 
      }
    })
    return sum
  }

  getNotSuccess() {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      if (item.work_status<'2') {
        sum = parseFloat(1) + parseFloat(sum) 
      }
    })
    return sum
  }

  getSummaryPercent(key) {
    let sum = 0
    let confirm_price = this.getSummary('confirm_price')
    let expense_amount = this.getSummary('expense_amount')
    let sum_exp = this.getSummaryExpense()
    if (key==='exp') {
      sum = (sum_exp*100)/confirm_price
    } else if (key==='balance') {
      sum = (expense_amount*100)/confirm_price
    }
    
    if (isNaN(sum)) {
      return 0
    } else {
      return sum.toFixed(2)
    }
  }

  getSummaryExpense() {
    let sum = 0
    sum = parseFloat(this.getSummary('expense_office'))+parseFloat(this.getSummary('expense_mechanic'))+parseFloat(this.getSummary('expense_stock'))
    return sum
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.incomeList.forEach(function(item,index) {
      let val = item[key] 
      if (val===''||val===null||val===undefined||isNaN(val)) {
        val = 0
      }
      sum = parseFloat(val) + parseFloat(sum)
    })
    return sum
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onMonthChange(val) {
    this.setState({
      month: val.value, isRange: false
    })
    this.loadData(this.state.year,val.value,this.state.query,this.state.clientId)
  }

  onYearChange(val) {
    this.setState({
      year: val.value, isRange: false
    })
    this.loadData(val.value,this.state.month,this.state.query,this.state.clientId)
  }

  onClientChange(val) {
    this.loadIncomeCategory(this.state.year,val.value)
    this.setState({
      clientId: val.value, isRange: false
    })
    //this.loadData(this.state.year,this.state.month,this.state.query,val.value)
  }

  onSearchClick(e) {
    let {clientId,year,month,query} = this.state
    this.setState({isRange: false})
    this.loadData(year,month,query,clientId)
  }

  onTextChange(e) {
    let {query} = this.state
    this.setState({query:e.target.value})
  }

  onTextSelect(e) {
    let {query} = this.state
    this.setState({query:e,isRange: false})
    this.loadData(this.state.year,this.state.month,e,this.state.clientId)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานสรุปรถออกรายได้คงเหลือ.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    let {year,month,query,clientId} = this.state
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportKKCBalance&year='+year+'&month='+month+'&q='+query+'&cat='+clientId
    } else{
      url = './pdf/v2/?startPage=PrintReportKKCBalance&year='+year+'&month='+month+'&q='+query+'&cat='+clientId
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,this.state.query,this.state.clientId)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.query,this.state.clientId)
    }  
  }

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{display:'inline-flex',verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            monthWCalendar={true}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.day+'/'+this.state.month+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
          />
        </FormGroup>  
        <div style={{ width: '180px', display: 'inline-block', marginLeft:'5px' }}>
          <SelectObject
            value={this.state.clientId}
            objectList={this.state.data.clientList}
            onChange={this.onClientChange.bind(this)}
          />
        </div>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <InputGroup>
            <CKAutocomplete
              placeholder="พิมพ์ชื่อค้นหา..."
              items={this.state.queryList}
              value={this.state.query}
              onChange={this.onTextChange.bind(this)}
              onSelect={this.onTextSelect.bind(this)}
            />
            <InputGroup.Addon className="btn" onClick={this.onSearchClick.bind(this)}><FontAwesome name='search' /></InputGroup.Addon>
          </InputGroup>
        </FormGroup>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <Button className='btn btn-danger' onClick={()=>{this.setState({query:''})}}><FontAwesome name='eraser' />&nbsp;ลบคำค้น</Button>
        </FormGroup>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>  
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.query,this.state.clientId)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const reportName = 'สรุปรายการค่าใช้จ่ายของรถลูกค้าแต่ละคัน'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText

    return (
      <Box>
        <Box.Header border={true}>          
          <Box.Title>{this.props.renderMenu()}</Box.Title>
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportKKCBalance.defaultProps = {
  show : false
}

export default ReportKKCBalance;





// WEBPACK FOOTER //
// ./src/view/report/ReportKKCBalance.js